module.exports = __webpack_public_path__ + "media/images/logo-black-a0457895218b61564074cbda8974e6a5.png";